import { Collection } from 'modules/core/lib/mobx-rest'
import type Company from 'modules/core/store/models/Company'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import type EmployeeGroup from 'modules/employees/store/models/EmployeeGroup'

class LegalEntities extends Collection<LegalEntity> {
  get cacheKey(): string {
    return 'legalEntities'
  }

  model() {
    return LegalEntity
  }

  get main(): LegalEntity | undefined {
    return this.find({ main: true })
  }
}

const singleton: LegalEntities = new LegalEntities()

export const companyLegalEntities = (company: Company) => {
  return singleton.filter({
    company_id: company.attributes.id,
  })
}
export const companyHasBrazilianLegalEntity = (company: Company) => {
  return companyLegalEntities(company).some(
    (legalEntity) => legalEntity.country === LegalEntity.countryDefaults.br
  )
}

export const employeeGroupLegalEntity = (employeeGroup: EmployeeGroup) => {
  const legalEntity = singleton.find({
    id: employeeGroup.attributes.legal_entity_id,
  })

  if (!legalEntity) {
    throw Error(`Error finding legalEntities with id = ${employeeGroup.attributes.legal_entity_id}`)
  }

  return legalEntity
}

export { LegalEntities }
export default singleton
